import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils'
import { Button, Card, Col, Form, notification, Row, Select } from 'antd'
import _ from 'lodash'

import { hideLoader, showLoader } from '../../modules/actions'

import Request from '../../request'
import { connect } from 'react-redux'
import Settings from '../../components/_utils/settings';
import moment from 'moment'

const Option = Select.Option

@Form.create()
class TransferCounsellor extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      allCounsellor: [],
      ratingArr: []
    }

  }

  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        dispatch(showLoader())
        let y = await Request.transferCounsellor(values)
        dispatch(hideLoader())
        if (y) {
          if (!y.error) {
            notification.success({
              message: 'Success',
              description: y.msg
            })
            form.resetFields()
          } else {
            notification.error({
              message: 'Error Saving',
              description: y.msg
            })
          }
        }
      }
    })
  }

  apiRequest = (params)=>{
    return new Promise(async(resolve)=>{
      let response = await Request.getLeadTransferHistory(params);
      resolve(response)
    })
  }
  async componentDidMount() {
    this.getAllRatings();
      let params = {
          sortField:'_id',
          sortOrder:'ascend',
          results: 200,
          active:true,
          userType:{$ne : "Student"}
      };

      let {data} = await Request.loadUser({...params, regExFilters: ['name']})
      let userArray = [];
      data.map((user, index)=>{
          userArray.push({
              _id: user._id,
              display: user.name
          })
      })
      this.setState({allCounsellor:userArray})

    // let { data } = await Request.loadCounsellor({
    //   results: 10000,
    //   atLevel: ['Counselling Desk']
    // })
    this.setState({
      allCounsellor: data, loading: false
    })
  }
  getAllRatings = async () => {
    let response = await Request.getRatingsDetails({
      results: 1000,
      count: 1000
    })
    this.setState({ ratingArr: response.data })
  }

  render() {

    let { allCounsellor } = this.state
    const {
      form: { getFieldDecorator, setFieldsValue }
    } = this.props

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
        md: { span: 12 }
      }
    }
    const { ratingArr } = this.state

    let columns = [
      {
        title:'From',
        key:'fromCounsellorId.name'
      },
      {
        title:'To',
        key:'toCounsellorId.name'
      },
      {
        title:'Desk',
        key:'atLevel'
      },
      {
        title:'Transferred By',
        key:'createdByUser.name'
      },
      {
        title:'Transfer Date',
        key:'createdByUser.time',
        render:(text,record)=>(
          <div>
            {record && moment(record.createdByUser.time).format('DD-MMMM-YYYY')}
          </div>
        )
      }
    ]

    let inputTypes = {
      fields: [
        {
          label: 'From',
          key: 'fromCounsellorId',
          required: true,
          showSearch: true,
          allowClear: true,
          placeholder: 'Select',
          keyAccessor: x => x._id,
          valueAccessor: x => x.name,
          type: 'select',
          disabled: false,
          options: allCounsellor ? allCounsellor : [],
          onChange: val => {
            setFieldsValue({
              fromCounsellorId: val
            })
          }
        },
        {
          label: 'To',
          key: 'toCounsellorId',
          required: true,
          showSearch: true,
          allowClear: true,
          placeholder: 'Select',
          keyAccessor: x => x._id,
          valueAccessor: x => x.name,
          type: 'select',
          disabled: false,
          options: allCounsellor ? allCounsellor : [],
          onChange: val => {
            setFieldsValue({
              toCounsellorId: val
            })
          }
        },
        {
          label: 'Desk',
          key: 'atLevel',
          required: true,
          type: 'select',
          options: Object.values(Settings.deskNameObj),
          onChange: val => {
            this.props.form.setFieldsValue({
              atLevel: val
            })
          }
        },
        {
          label: 'Rating',
          key: 'rating',
          required: true,
          type: 'select',
          mode: 'multiple',
          keyAccessor: (x) => x._id,
          valueAccessor: (x) => x.ratingName,
          options: ratingArr,
          onChange: val => {
            this.props.form.setFieldsValue({
              rating: val
            })
          }
        }
      ]
    }
    return (
      <PageHeaderWrapper title={'Lead Transfer'}>
        <Form onSubmit={this.handleSubmit}>
          <GetAllFormFields
            inputSchema={inputTypes}
            refresh={this.refreshFxn}
            loading={this.props.loading}
            getFieldDecorator={getFieldDecorator}
          />

          <Button
            type="primary"
            htmlType="submit"
            style={{ marginBottom: 10, marginLeft: '33%' }}
            loading={this.props.loading}>
            SAVE
          </Button>
        </Form>
        <Card title={`Lead Transfer History`} style={{marginTop:'10px'}}>
          <TableComp
          ref={this.table}
          columns={columns}
          apiRequest={this.apiRequest}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: '20',
            pageSizeOptions: ['10', '20', '50', '100', '1000']
        }} />
        </Card>
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransferCounsellor)
